import { Component } from '@angular/core';
import { AuthService } from '@core';

@Component({
    selector: 'app-service-portal',
    templateUrl: './service-portal.component.html',
    styleUrls: ['./service-portal.component.scss'],
    standalone: false,
})
export class ServicePortalComponent {
    public isLoggedIn: boolean;

    public constructor(public authService: AuthService) {
        this.authService.isLoggedIn$.subscribe((val) => (this.isLoggedIn = val));
    }
}
